export default __webpack_public_path__ + "media/images/mailer/icon_file_download-e98f19174f391051ba2cf5df30b74425.png";